export default "__VITE_ASSET__408d4908__"